import { render, staticRenderFns } from "./RequestSuccessView.vue?vue&type=template&id=04b95b2b&"
import script from "./RequestSuccessView.vue?vue&type=script&lang=js&"
export * from "./RequestSuccessView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports